import React from 'react';

import { IIconProps, TIconType } from '../interface';

const EditCircleIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-id='icon-button'
			data-testid='edit-circle'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M8.14054 3.33152L12 2.51117L15.8595 3.33152L19.0516 5.65073L21.0244 9.06779L21.4368 12.9919L20.2176 16.7444L17.5774 19.6766L13.9728 21.2815H10.0272L6.42261 19.6766L3.78243 16.7444L2.56315 12.9919L2.97559 9.06779L4.94843 5.65073L8.14054 3.33152Z'
				data-id='icon-button'
				fill='currentColor'
				stroke='#2E2E6B'
			/>
			<path
				d='M15.4803 9.81155C15.5329 9.86435 15.5625 9.93587 15.5625 10.0104C15.5625 10.085 15.5329 10.1565 15.4803 10.2093L14.8927 10.7975L13.7658 9.67069L14.3535 9.08248C14.4063 9.02967 14.4779 9 14.5526 9C14.6273 9 14.699 9.02967 14.7518 9.08248L15.116 9.44701L15.4803 9.81155ZM14.4943 11.1953L13.3675 10.0685L9.52889 13.9076C9.49788 13.9386 9.47454 13.9764 9.46072 14.018L9.00716 15.3781C8.99894 15.4029 8.99777 15.4295 9.00379 15.4549C9.00981 15.4804 9.02278 15.5036 9.04126 15.5221C9.05973 15.5406 9.08297 15.5535 9.10839 15.5596C9.13382 15.5656 9.16041 15.5644 9.1852 15.5562L10.5453 15.1026C10.5869 15.089 10.6247 15.0658 10.6557 15.035L14.4943 11.1953Z'
				data-id='icon-button'
				fill='#2E2E6B'
			/>
			<path
				d='M15.4803 9.81155C15.5329 9.86435 15.5625 9.93587 15.5625 10.0104C15.5625 10.085 15.5329 10.1565 15.4803 10.2093L14.8927 10.7975L13.7658 9.67069L14.3535 9.08248C14.4063 9.02967 14.4779 9 14.5526 9C14.6273 9 14.699 9.02967 14.7518 9.08248L15.116 9.44701L15.4803 9.81155ZM14.4943 11.1953L13.3675 10.0685L9.52889 13.9076C9.49788 13.9386 9.47454 13.9764 9.46072 14.018L9.00716 15.3781C8.99894 15.4029 8.99777 15.4295 9.00379 15.4549C9.00981 15.4804 9.02278 15.5036 9.04126 15.5221C9.05973 15.5406 9.08297 15.5535 9.10839 15.5596C9.13382 15.5656 9.16041 15.5644 9.1852 15.5562L10.5453 15.1026C10.5869 15.089 10.6247 15.0658 10.6557 15.035L14.4943 11.1953Z'
				data-id='icon-button'
				fill='#2E2E6B'
			/>
		</svg>
	);
};

export default EditCircleIcon;
